// src/services/authService.js
import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getDepartement = async () => {
    return userRequest.get(`${DOMAIN}/api/departement`);
  };

export const getDepartementOne = async (id) => {
  console.log(id)
    return userRequest.get(`${DOMAIN}/api/departement/one?id_departement=${id}`);
  };

export const postDepartement = async (data) => {
  return userRequest.post(`${DOMAIN}/api/departement`, data);
};

export const deletePutDepartement = async (id) => {
  return userRequest.put(`${DOMAIN}/api/departement/supprime_put?id=${id}`);
};


export const putDepartement = async (id, data) => {
  return userRequest.put(`${DOMAIN}/api/departement?id_departement=${id}`, data);
};

